module.exports = __webpack_public_path__ + "img/teratakpaklong.7fedd71c.jpg";